import { get, internalDestroy, internalPost, internalPut } from './';

export const getStyles = async ({
  locale,
  search,
  discarded,
  page,
  perPage,
  direction = 'desc',
  order = 'id',
}) => {
  const params = new URLSearchParams({
    ...(locale && { locale }),
    ...(search && { search }),
    ...(page && { page }),
    ...(perPage && { perPage }),
    ...(discarded && discarded !== 'undefined' && { discarded }),
    order,
    direction,
  });
  return get(`/styles?${params.toString()}`);
};

export const getStyle = ({ styleId, locale }) => {
  return get(`/styles/${styleId}?locale=${locale}`);
};

export const createStyle = ({ payload, locale }) => {
  return internalPost(`/styles?locale=${locale}`, payload);
};

export const updateStyle = ({ styleId, payload, locale }) => {
  return internalPut(`/styles/${styleId}?locale=${locale}`, payload);
};

export const deleteStyle = ({ styleId, payload }) => {
  return internalDestroy(`/styles/${styleId}`, payload);
};
